import apiMiddleware from "../../../../../api/apiMiddleware";

/** Unwrap Laravel list payloads from axios or response.data shapes. */
export const extractApiList = (payload) => {
  if (!payload) return [];

  if (typeof payload.status === "number" && payload.data) {
    const list = payload.data?.data;
    return Array.isArray(list) ? list : Array.isArray(payload.data) ? payload.data : [];
  }

  if (payload.status === true && Array.isArray(payload.data)) {
    return payload.data;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  return [];
};

export const list = async (page = 1) => {
  const response = await apiMiddleware.get(
    `/attractions?page=${page}`
  ); 
  return response.data;
};



export const add = async (formData) => {
    const response = await apiMiddleware.post(
      "/attractions",
      formData
    );
    return response.data;
};


export const update = async (id, formData) => {  
  const response = await apiMiddleware.post(
    `/attractions/${id}?_method=PUT`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

export const updateAttractionStage = async (id, currentStage) => {
  const formData = new FormData();
  formData.append("current_stage", String(currentStage));
  return update(id, formData);
};

export const remove = async (id) => {
  const response = await apiMiddleware.delete(
    `/attractions/${id}`
  );
  return response.data;
};



export const getAttractionById = async (id) => {
  const response = await apiMiddleware.get(
    `/attractions/${id}`
  );
  return response.data;
};


/*

export const getAttractionById = async (id) => {
  console.log("getAttractionById called with id from admin:", id);
  const response = await apiMiddleware.get(
    `/attractions/${id}`
  );
  console.log("response in admin:", response);
  return response.data;
};
*/

// FAQ related functions
export const getAttractionFAQ = async (attractionId) => {
  
  const response = await apiMiddleware.get(
    `/attractions/${attractionId}/faqs`
  );
  return response.data;
};

export const createAttractionFAQ = async (data) => {

  const response = await apiMiddleware.post(`/attractions/faqs`, data);
  return response;
};

// Route::put('attraction-faqs/{attractionId}', 'update');         // Update all FAQs

export const updateAttractionFAQ = async (attractionId, data) => {
  const response = await apiMiddleware.post(
    `/attractions/${attractionId}/faqs?_method=PUT`,
    data
  );
  return response;

};

export const deleteAttractionFAQ = async (faqId) => {
  const response = await apiMiddleware.delete(
    `/attractions/faqs/${faqId}`
  );
  return response;
};

export const getAttractionInclusionsExclusions = async (attractionId) => {
  const response = await apiMiddleware.get(
    `/attractions/${attractionId}/inclusions-exclusions`
  );
  return response.data;
};

export const updateAttractionInclusionsExclusions = async (attractionId, data) => {
  const response = await apiMiddleware.put(
    `/attractions/${attractionId}/inclusions-exclusions`,
    data
  );
  return response.data;
};

// Terms and Conditions related functions
export const getAttractionTermsAndConditions = async (attractionId) => {
  const response = await apiMiddleware.get(
    `/attractions/${attractionId}/terms-and-conditions`
  );
  return response.data;
};

// Route::post('attractions/{attractionId}/terms-and-conditions', 'store');

export const saveAttractionTermsAndConditions = async (data) => {

  // Use the resource POST endpoint
  const requestData = {
    attraction_id: data.attraction_id, // Required by API validation
    description: data.description, // Map name to description as expected by API
    current_stage: data.current_stage
  };
  const response = await apiMiddleware.post(`/attractions/${data.attraction_id}/terms-and-conditions`, requestData);
  return response.data;
};

export const updateAttractionTermsAndConditions = async (data) => {  
  const response = await apiMiddleware.post(`/attractions/${data.attraction_id}/terms-and-conditions/${data.id}?_method=PUT`, data);
  return response.data;  
};

// Attraction Categories related functions
export const getAttractionCategories = async () => {
  const response = await apiMiddleware.get(`/active-attraction-categories`);
  return response.data;
};

export const createAttractionCategory = async (data) => {
  const response = await apiMiddleware.post(
    `/attraction-categories`,
    data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

export const updateAttractionCategory = async (id, data) => {
  const response = await apiMiddleware.post(
    `/attraction-categories/${id}?_method=PUT`,
    data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

export const deleteAttractionCategory = async (id) => {
  const response = await apiMiddleware.delete(
    `/attraction-categories/${id}`
  );
  return response.data;
};

// Attraction Ticket Types (per attraction wizard)
export const getAttractionTickets = async (attractionId) => {
  const response = await apiMiddleware.get(
    `/attractions/${attractionId}/ticket-types`
  );
  return response.data;
};

export const createAttractionTickets = async (attractionId, data) => {
  const response = await apiMiddleware.post(
    `/attractions/${attractionId}/ticket-types`,
    data
  );
  return response.data;
};

export const updateAttractionTicket = async (attractionId, ticketId, data) => {
  const response = await apiMiddleware.put(
    `/attractions/${attractionId}/ticket-types/${ticketId}`,
    data
  );
  return response.data;
};

export const deleteAttractionTicket = async (attractionId, ticketId) => {
  const response = await apiMiddleware.delete(
    `/attractions/${attractionId}/ticket-types/${ticketId}`
  );
  return response.data;
};

export const deleteAttractionGalleryImage = async (id, imageId) => { 
  const response = await apiMiddleware.post(
    `/attractions/${id}/delete-gallery-image`,
    { image_ids: [imageId] }
  );
  return response;
};

// Attraction Pricing Services
export const getAttractionTicketTypesForPricing = async (attractionId) => {
  const response = await apiMiddleware.get(
    `/attractions/${attractionId}/ticket-types`
  );
  return response.data; 
};

export const saveAttractionPricing = async (data) => {
  const response = await apiMiddleware.post(`/attractions/pricing`, data);

  if (response.data && data.closeout_dates && data.closeout_dates.length > 0) {
    try {
      await addCloseoutDates({
        attraction_id: data.attraction_id,
        closeout_dates: data.closeout_dates,
      });
    } catch (error) {
      console.error("Failed to save closeout dates:", error);
    }
  }

  return response.data;
};

export const getAttractionPricing = async (attractionId) => { 
  const response = await apiMiddleware.get(
    `/attractions/pricing/${attractionId}`
  );
  return response.data;
};







export const updateAttractionPricing = async (data) => {
  const response = await apiMiddleware.post(
    `/attractions/pricing/${data.attraction_id}?_method=PUT`,
    data
  );

  if (response.data && data.closeout_dates && data.closeout_dates.length > 0) {
    try {
      await bulkUpdateCloseoutDates(data.attraction_id, {
        closeout_dates: data.closeout_dates,
      });
    } catch (error) {
      console.error("Failed to update closeout dates:", error);
    }
  }

  return response.data;
};

// Close out dates functions
export const addCloseoutDates = async (data) => {
  const response = await apiMiddleware.post('/attractions/closeout-dates', data);
  return response.data;
};

export const getCloseoutDates = async (attractionId) => {
  const response = await apiMiddleware.get(`/attractions/${attractionId}/closeout-dates`);
  return response.data;
};

export const updateCloseoutDates = async (attractionId, data) => {
  const response = await apiMiddleware.put(`/attractions/closeout-dates/${attractionId}`, data);
  return response.data;
};

export const bulkUpdateCloseoutDates = async (attractionId, data) => {
  const response = await apiMiddleware.put(`/attractions/closeout-dates-bulk/${attractionId}`, data);
  return response.data;
};

export const removeCloseoutDates = async (attractionId, data) => {
  const response = await apiMiddleware.delete(
    `/attractions/closeout-dates/${attractionId}`,
    { data }
  );
  return response.data;
};

export const getAttractionCancellationPolicy = async (attractionId) => {
  const response = await apiMiddleware.get(
    `/attractions/cancellation-policies/${attractionId}`
  );
  return response.data;
};

export const createAttractionCancellationPolicy = async (data) => {
  const response = await apiMiddleware.post(
    `/attractions/cancellation-policies`,
    data
  );
  return response.data;
};

export const updateAttractionCancellationPolicy = async (attractionId, data) => {
  const response = await apiMiddleware.put(
    `/attractions/cancellation-policies/${attractionId}`,
    data
  );
  return response.data;
};

export const deleteAttractionCancellationPolicy = async (attractionId) => {
  const response = await apiMiddleware.delete(
    `/attractions/cancellation-policies/${attractionId}`
  );
  return response.data;
};

export const submitAttractionForApproval = async (id) => {
  const formData = new FormData();
  formData.append("submit_for_approval", "1");
  return update(id, formData);
};
